import React from "react"
import { useTranslation } from "react-i18next"

import { TextInput } from "shared/ui/input/text/TextInput"

import { FLOOR_LABEL_MAX_LENGTH } from "entities/floors/types/Floor"

import { useFloorFormContext } from "../../contexts/FloorFormContext"

export interface FloorLabelInputProps {
  hideLabel?: boolean
  autoFocus?: boolean
}

export const FloorLabelInput = React.memo(
  ({ hideLabel, autoFocus }: FloorLabelInputProps) => {
    const { t } = useTranslation()
    const { isReadonly, isDisabled } = useFloorFormContext()

    return (
      <TextInput.Root
        name="floor.label"
        className="floor-form__label"
        label={t("Floor.label")}
        maxLength={FLOOR_LABEL_MAX_LENGTH}
        autoFocus={autoFocus}
        readonly={isReadonly}
        disabled={isDisabled}
        required
      >
        {!hideLabel ? <TextInput.Label /> : null}
        <TextInput.Focus>
          <TextInput.Input type="text" data-testid="floor__label__input" />
          <TextInput.Counter />
        </TextInput.Focus>
        <TextInput.Readonly />
        <TextInput.ErrorMessage />
      </TextInput.Root>
    )
  }
)
